import React from "react";

const style = { padding: 0, margin: 0 };

export const BlkCheckBox = ({ field, form, styleInput, ...props }) => (
    <div className={"form-check"} style={style}>
        <label className="form-check-label">
            <input
                className="form-check-input"
                style={styleInput}
                type="checkbox"
                {...field}
                {...props}
                disabled={props.readOnly}
                onChange={e => {
                    form.setFieldValue(field.name, e.target.checked ? 1 : 0);
                }}
                checked={field.value === 1 || field.value === "1" || field.value === true || field.value === "true"}
            />
            {props.label}
            <span className="form-check-sign">{props.tag ? props.tag : " "}</span>
        </label>
        {form.touched[field.name]}
    </div>
);
